import { render } from "./DropDownListBibMotivoBaixa.vue?vue&type=template&id=47bea915&ts=true"
import script from "./DropDownListBibMotivoBaixa.vue?vue&type=script&lang=ts"
export * from "./DropDownListBibMotivoBaixa.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__